/**
 * LoadingState
 * Small shared placeholder used across public and dashboard pages.
 */
export default function LoadingState({ label = 'Loading...' }) {
  return (
    <div className="state-card">
      <p>{label}</p>
    </div>
  );
}
